import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Checkbox, Row, Col, Pagination } from "antd";
import { ApprovalReasonModal } from "../../common/ApprovalReasonModal";
import { LeaveList } from "./LeaveList";
import "../../../App.css";
import {
  Status,
  StatusByHexColor,
} from "../../../components/model/common/Status";
import { useTranslation } from "react-i18next";

export default function LeaveApplicationVoidForm({
  isLoading,
  data,
  selectedItems,
  onAdd,
  onView,
  onVoided,
  onItemSelected,
  onAttachmentClicked,
  setCurrentYear,
  pagination,
  setPagination,
  resetPagination,
}) {
  const { t } = useTranslation();
  const [showReasonForm, setShowReasonForm] = useState(false);
  const [tempItem, setTempItem] = useState();

  function submitVoidReason(reason) {
    setShowReasonForm(false);
    if (tempItem) {
      //void single item
      onVoided([tempItem], reason);
    } else {
      //void multiple items
      onVoided(selectedItems, reason);
    }
  }

  function voidLeave(selectedLeave) {
    setTempItem(selectedLeave);
    setShowReasonForm(true);
  }

  function voidLeaves() {
    setTempItem(null);
    setShowReasonForm(true);
  }

  function getListActions(item) {
    return [
      <div key>
        <span
          style={{
            float: "left",
            fontStyle: "italic",
            marginLeft: "50px",
            color: StatusByHexColor[item.Status],
          }}
        >
          {Status[item.Status]}
        </span>

        <Button
          type="primary"
          size="default"
          onClick={() => voidLeave(item)}
          style={{
            display: !item.IsViewOnly ? "" : "none",
          }}
        >
          {t("general.void")}
        </Button>
      </div>,
    ];
  }

  function selectAllItems(isSelected) {
    if (onItemSelected) {
      if (isSelected) {
        onItemSelected(data.filter((x) => !x.IsViewOnly));
      } else {
        onItemSelected([]);
      }
    }
  }

  const footerElement = (footerValue, totalPagination) => (
    <Row>
      <Col span={2} style={{ paddingTop: "5px" }}>
        <Checkbox
          indeterminate={
            selectedItems.length &&
            selectedItems.length < data.filter((x) => !x.IsViewOnly).length
          }
          checked={
            selectedItems.length &&
            selectedItems.length === data.filter((x) => !x.IsViewOnly).length
          }
          onChange={(event) => selectAllItems(event.target.checked)}
        >
          {t("general.select_all")}
        </Checkbox>
      </Col>
      <Col span={22} style={{ textAlign: "right" }}>
        <Pagination
          style={{ display: "inline-flex", paddingRight: 10 }}
          defaultCurrent={pagination.current}
          current={pagination.current}
          total={totalPagination}
          onChange={onChangePagination}
          showTotal={(total) =>
            t("general.total") + ` ${total} ` + t("general.records")
          }
          defaultPageSize={pagination.pageSize}
          pageSize={pagination.pageSize}
        />
        {t("general.total")} :{" "}
        <b style={{ color: "#0070cc" }}>
          {footerValue} {t("general.days")}
        </b>
        <Button
          type="primary"
          style={{ marginLeft: "10px" }}
          disabled={selectedItems.length === 0 || isLoading}
          onClick={voidLeaves}
        >
          {t("general.void")}
        </Button>
      </Col>
    </Row>
  );

  function onChangePagination(page, pageSize) {
    setPagination({
      current: page,
      minIndex: (page - 1) * pageSize,
      maxIndex: page * pageSize,
      pageSize: pageSize,
    });
  }

  return (
    <div>
      <LeaveList
        isLoading={isLoading}
        data={data}
        onAdd={onAdd}
        onItemViewed={onView}
        isSelectable={true}
        selectedItems={selectedItems}
        onItemSelected={onItemSelected}
        onListActionsRendered={getListActions}
        filterCheckedText={t("leaveApplicationForm.show_approved_leave_only")}
        footerElement={footerElement}
        onAttachmentClicked={onAttachmentClicked}
        setCurrentYear={setCurrentYear}
        pagination={pagination}
        resetPagination={resetPagination}
      />

      <ApprovalReasonModal
        isVisible={showReasonForm}
        reasonType={"Void"}
        onSaved={submitVoidReason}
        onCancelled={() => setShowReasonForm(false)}
      />
    </div>
  );
}

LeaveApplicationVoidForm.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  selectedItems: PropTypes.array.isRequired,
  onAdd: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
  onVoided: PropTypes.func.isRequired,
  onItemSelected: PropTypes.func.isRequired,
  onAttachmentClicked: PropTypes.func.isRequired,
  setCurrentYear: PropTypes.func.isRequired,
  pagination: PropTypes.object.isRequired,
  setPagination: PropTypes.func.isRequired,
  resetPagination: PropTypes.func.isRequired,
};
